import axios from '../utils/axios';

export default function generateTestLead(adminId, data) {
  return (
    axios.post('/admin/' + adminId + '/courses/generate-test-lead', data)
  )
}
